import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { Eye, EyeOff } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Bem-vindo(a)!");
      if (next && next.startsWith("/") && !next.startsWith("//")) return nav(next);
      nav(u.role === "admin" ? "/admin" : "/conta");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-10 sm:py-16">
      <h1 className="text-3xl font-bold text-center" style={{ fontFamily: "Outfit" }}>Entrar</h1>
      <form onSubmit={submit} className="mt-8 space-y-4 bg-white border rounded-xl p-6">
        <div>
          <Label>E-mail</Label>
          <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div>
          <Label>Senha</Label>
          <div className="relative">
            <Input
              data-testid="login-password"
              type={showPwd ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="pr-10"
            />
            <button
              type="button"
              onClick={() => setShowPwd((v) => !v)}
              data-testid="login-toggle-password"
              aria-label={showPwd ? "Ocultar senha" : "Mostrar senha"}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-neutral-500 hover:text-neutral-900 p-1"
            >
              {showPwd ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          </div>
          <div className="text-right mt-1">
            <Link to="/recuperar-senha" data-testid="forgot-password-link" className="text-xs text-[#C91F1F] font-semibold hover:underline">
              Esqueci minha senha
            </Link>
          </div>
        </div>
        <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full bg-[#C91F1F] hover:bg-[#9F1515] h-11">
          {loading ? "Entrando..." : "Entrar"}
        </Button>
        <p className="text-sm text-center text-neutral-600">
          Não tem conta? <Link to="/cadastro" className="text-[#C91F1F] font-semibold">Cadastre-se</Link>
        </p>
      </form>
    </div>
  );
}
